import React from 'react';

import { useLoginRecordsState } from './LoginRecordsContext';

import Table from '../../Shared/UI/Table/components/Table';
import Thead from '../../Shared/UI/Table/components/Thead';
import Tbody from '../../Shared/UI/Table/components/Tbody';
import Tr from '../../Shared/UI/Table/components/Tr';
import Th from '../../Shared/UI/Table/components/Th';
import Td from '../../Shared/UI/Table/components/Td';

const LoginRecordsTable = () => {
  const loginRecordsState = useLoginRecordsState();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  return (
    <Table>
      <Thead>
        <Tr>
          <Th>Email</Th>
          <Th>Remote IP</Th>
          <Th>Status</Th>
          <Th>Date/Time</Th>
        </Tr>
      </Thead>
      <Tbody>
        {loginRecordsState?.loginRecords?.map(loginRecord => (
          <Tr key={loginRecord.id}>
            <Td>{loginRecord.email}</Td>
            <Td>{loginRecord.remoteIp}</Td>
            <Td>{loginRecord.failed ? 'Failed' : 'Success'}</Td>
            <Td>{formatDate(loginRecord.createdAt)}</Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default LoginRecordsTable;
